import {IModel, IPoint} from "makerjs";
import { makerjs } from "../../../../source/js/shared/rendering/makerjs";

export default class GuideLine {
	private readonly startPoint: IPoint;
	private readonly endPoint: IPoint;

	constructor( startPoint: IPoint, endPoint: IPoint ) {
		this.startPoint = startPoint;
		this.endPoint = endPoint;
	}

	getModel(): IModel {
		const model = {} as IModel;
		makerjs.model.addPath(model, new makerjs.paths.Line(this.startPoint, this.endPoint), 'guideline');

		return model;
	}
}
